<template>
  <div>
    <viewTable
        ref="viewTable"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="productionManage/operationReport"
        @select="selectHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="派工单号">
            <el-input v-model.trim="filter.taskDispatchBillNo" placeholder="请输入派工单号" clearable/>
          </el-form-item>
          <el-form-item label="工单编号">
            <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
          </el-form-item>
          <el-form-item label="汇报状态">
            <el-select v-model="filter.reportStatus" placeholder="请选择汇报状态" clearable>
              <el-option label="成功" :value="1"/>
              <el-option label="失败" :value="0"/>
              <el-option label="全部" :value="-1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="工序编号">
            <el-input v-model.trim="filter.processNo" placeholder="请输入工序编号" clearable/>
          </el-form-item>
          <el-form-item label="工序名称">
            <el-input v-model.trim="filter.processName" placeholder="请输入工序名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="otherBtn">
        <el-button type="primary" :disabled="!selection.length" @click="reportHandle"> 工序汇报 </el-button>
      </template>
    </viewTable>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  export default {
    components: { viewTable },
    data() {
      return {
        filter: {
          taskDispatchBillNo: "",
          materialNo: "",
          materialName: "",
          productionOrderNo: "",
          processName: "",
          processNo: "",
          reportStatus: 0,
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "taskDispatchBillNo",
            width: 140,
            align: "center",
          },
          {
          tooltip: true,
            key: "productionOrderNo",
            width: 140,
            align: "center",
          },
          {
          tooltip: true,
            key: "reportStatusName",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "reportTime",
            width: 160,
            align: "center",
          },
          {
          tooltip: true,
            key: "finishTime",
            width: 160,
            align: "center",
          },
          {
          tooltip: true,
            key: "processIndex",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "processNo",
            width: 120,
            align: "center",
          },
          {
            key: "processName",
            width: 120,
            align: "center",
            tooltip: true,
          },
          {
          tooltip: true,
            key: "quantity",
            width: 80,
            align: "center",
          },
          {
          tooltip: true,
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            key: "materialName",
            minWidth: 360,
            tooltip: true,
          },
          {
            key: "reportMessage",
            minWidth: 200,
            tooltip: true,
          },
        ],
        selection: [],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 工序汇报
      reportHandle() {
        const arr = this.selection.filter((item) => item.reportStatus === 1);
        if (arr.length) {
          this.$confirm("请选择未汇报的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$http.post("basic", "productionManage/operationReport", this.selection).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.selection = [];
              this.loadData();
            }
          });
        }
      },
      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
